import type { Country } from 'types';
import { SelectField, SelectFieldProps } from '@ff-it/form';
import { ReactElement } from 'react';
import useSWR from 'swr/immutable';

const optionProps = {
  getOptionLabel: (country: Country) => country.name,
  getOptionValue: (country: Country) => country.code,
};

function useCountries(): Country[] {
  const { data: countries } = useSWR<{ results: Country[] }>({
    method: 'GET',
    url: 'core/countries/',
  });
  return countries?.results || [];
}

export function CountryField(
  props: Omit<SelectFieldProps<Country>, 'options' | 'loadOptions' | 'getOptionLabel' | 'getOptionValue'>,
): ReactElement {
  const countries = useCountries();

  return <SelectField options={countries} {...props} {...optionProps} />;
}
